import { useEffect, useState } from "react";
import { getProducts } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import ProductCard from "@/components/ProductCard";
import Marquee from "@/components/Marquee";
import { motion } from "framer-motion";

export default function Shop() {
  const { t } = useLang();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    getProducts().then(setProducts).catch(() => {});
    window.scrollTo(0, 0);
  }, []);

  return (
    <main data-testid="shop-page" className="pt-32 croc-bg text-foreground min-h-screen">
      <section className="mx-auto max-w-[1400px] px-6 md:px-8 mb-14">
        <motion.p
          initial={{ opacity: 0 }} animate={{ opacity: 1 }}
          className="font-mono-x text-xs uppercase tracking-[0.3em] text-[hsl(var(--accent))] mb-4 font-bold"
        >
          {t("shop.meta", { n: products.length })}
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="font-display font-extrabold text-5xl sm:text-7xl md:text-8xl uppercase tracking-tighter leading-[0.9] text-[hsl(var(--primary))]"
        >
          {t("shop.title")}
        </motion.h1>
      </section>

      <section className="mx-auto max-w-[1400px] px-6 md:px-8 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
          {products.map((p, i) => (
            <ProductCard key={p.slug} product={p} index={i} />
          ))}
        </div>
      </section>

      <Marquee text={t("shop.marquee")} variant="outline" />
    </main>
  );
}
